import { OfflineBudgetTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import { Budget } from '../../../../../../store/planStore';

interface TypeGroups {
  budget: Budget;
}

const calculateOfflineTotalBudgetRowData = (
  rows: OfflineBudgetTableRowData[]
): OfflineBudgetTableRowData => {
  const typeGroups: Record<string, TypeGroups> = {
    tv: { budget: { value: 0, currency: 'PLN' } },
    outdoor: { budget: { value: 0, currency: 'PLN' } },
    'tech cost': { budget: { value: 0, currency: 'PLN' } },
  };

  rows.forEach((row) => {
    row.children?.forEach(({ budget }) => {
      typeGroups[row.touchpoint].budget.value += budget.value;
    });
  });

  return {
    touchpoint: 'mediaPlanning.totalOffline',
    budget: rows.reduce(
      (acc, row) => ({
        currency: row.budget.currency,
        value: acc.value + row.budget.value,
      }),
      { currency: '', value: 0 }
    ),
    children: Object.entries(typeGroups).map(([typeGroup, metrics]) => ({
      type: typeGroup,
      budget: metrics.budget,
    })),
  };
};

export default calculateOfflineTotalBudgetRowData;
